module.exports = __webpack_public_path__ + "assets/img/UnifiedAuthentication.90a5e0d5.png";